/* eslint-disable import/prefer-default-export */

// https://www.ietf.org/rfc/rfc5322.txt
export const emailRfc5322Regex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const phoneNumberRegex = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

// The stand-in the eScript import stores for an invalid partner email: <uuid>@perfectrx.com. Only
// the UUID form matches, so a real perfectrx.com address never does. Never emailed.
export const placeholderEmailRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}@perfectrx\.com$/i;

export const passwordRegex = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[^a-zA-Z\d:]).{8,}$/;

export const creditCardRegex =
  /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;

export const zipCodeRegex = /^\d{5}(-\d{4})?$|^\d{5}-$/;

export const npiRegex = /^[A-Za-z0-9]{10}$/;

export const nameRegex =
  /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžæÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;

export const ndcRegex = /^(?:\d{4}-\d{4}-\d{2}|\d{5}-(?:\d{3}-\d{2}|\d{4}-\d{1,2})|\d{10}|\d{11})$/;

// Alphanumeric plus the punctuation real catalog drug names use (e.g.
// "AOD-9604/MOTS-C", "BPC-157/GHK-U/KPV/TB500", "AA-Curex", "NAD+").
export const drugNameAllowedCharRegex = /^[a-zA-Z0-9\s\-_.()/\\+]$/;
export const drugNameAllowedValueRegex = /^[a-zA-Z0-9\s\-_.()/\\+]*$/;
export const drugNameAllowedCharsHint = 'Must be alphanumeric / - / _ / . / () / \\ / / / +';

// Add Inventory Item's brand name allows the same characters (e.g. "Nad+", "B12+").
export const brandNameAllowedCharRegex = /^[a-zA-Z0-9\s\-_.()/\\+]$/;
export const brandNameAllowedValueRegex = /^[a-zA-Z0-9\s\-_.()/\\+]*$/;

// The 3-character drug code segment of a catalog Product ID (PRX|FLX|2000|CA): a
// letter, then two letters or digits (e.g. FLX, TB5). Generated codes are still
// letters only.
export const drugCodeAllowedValueRegex = /^[A-Za-z][A-Za-z0-9]{2}$/;
